import { HttpContextToken } from "@angular/common/http";

export const INTERCEPTInternalServerError = new HttpContextToken(() => true);
export const INTERCEPTForbidden = new HttpContextToken(() => true);
export const INTERCEPTNotFound = new HttpContextToken(() => true);
export const INTERCEPTUnauthorized = new HttpContextToken(() => true);
export const INTERCEPTRequestTimeout = new HttpContextToken(() => true);
export const INTERCEPTConflict = new HttpContextToken(() => true);
export const INTERCEPTServiceUnavailable = new HttpContextToken(() => true);
export const INTERCEPTNotModified = new HttpContextToken(() => true);